import React, { useState, useEffect, useRef } from "react";
import { ChatList, MessageBox, Input, Button } from "react-chat-elements";
import "react-chat-elements/dist/main.css";
import "../../../assets/css/ChatComponent.css";
import axios from "axios";
import { FaPlus, FaPaperclip, FaPaperPlane } from "react-icons/fa";
import { io } from "socket.io-client";
import { useTranslation } from "react-i18next";
import ApiConfig, { NODE_URL } from "../../../api/ApiConfig";
import Params from "../../../config/Params";
import InfiniteScroll from "react-infinite-scroll-component";
import profilePic from "../../../assets/images/masterdatapic/profilePic.png";


const Chat = () => {
  const [chatList, setChatList] = useState([]);
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [attachmentPreview, setAttachmentPreview] = useState(null);
  const [page, setPage] = useState(1); // Current page number
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [hasMore, setHasMore] = useState(true); // Check if there's more data
  const [showModal, setShowModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [conLoad, setconLoad] = useState(false);
  const [newChatList, setNewChatList] = useState([]);
  const pageLimit = 10;
  const toggleModal = () => setShowModal(!showModal);
  // Initialize socket connection
  const socket = React.useRef(null);
  console.log(Params.customer_id, Params.teacher_id, "custid");


  const validateImage = (url, fallback) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;

      img.onload = () => resolve(url);
      img.onerror = () => resolve(fallback);
    });
  };

  useEffect(() => {
    // Connect to the socket server
    socket.current = io(ApiConfig.NODE_URL, {
      query: {
        customerId: Params.customer_id,
        user_type: "teacher",
        userId: Params.teacher_id,
      },
    });

    // Join the room when a chat is selected
    if (activeChat) {
      socket.current.emit("room", {
        chatRoomId: activeChat?.id,
      });
    }

    // Handle incoming messages
    socket.current.on("message", (data) => {
      console.log(data, "response data");
      const attachments = data.list[0]?.message_attachments || [];
      const formattedAttachments = attachments.map((attachment) => ({
        url: `https://app.edsys.in:3000/${attachment.attachment_url}`,
        type: attachment.attachment_type,
        name: attachment.attachment_name,
      }));
      const newMessage = {
        position: data.list[0]?.message_from_id === Params.teacher_id ? "right" : "left",
        name:
          data.list[0]?.message_from_id === Params.teacher_id
            ? "Teacher"
            : activeChat.title,
        avatar:
          data.list[0]?.message_from_id === Params.teacher_id
            ? "Teacher"
            : activeChat.avatar,
        type: "text", // Default type
        text: data.list[0]?.message_text || "",
        date: new Date(data.list[0]?.message_date_time || Date.now()),
        attachments: formattedAttachments, // Add attachments to the message object
      };

      setMessages((prevMessages) => [newMessage, ...prevMessages]);
    });

    // Cleanup socket on unmount
    return () => {
      socket.current.disconnect();
    };
  }, [activeChat]);
  // Fetch API Data
  const fetchChatList = async (pageNo) => {
    if (isLoading || !hasMore) return; // Prevent duplicate calls

    setIsLoading(true);

    axios(ApiConfig.CHAT_LIST, {
      method: "GET",
      params: {
        teacher_id: Params.teacher_id,
        page_no: pageNo,
        page_limit: 20,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Basic YnJva2VyOmJyb2tlcl8xMjM=",
        api_key: Params.api_key,
        customer_id: Params.customer_id,
      },
    })
      .then(async (response) => {
        if (response.data.result && response.data.list) {



          const formattedChatList = response.data.list.map((item) => {
            return {
              id: item.chat_thread_id,
              title: item.receptient_name,
              receiverId:
                item.chat_thread_from_id !== Params.teacher_id
                  ? item.chat_thread_from_id
                  : item.chat_thread_to_id,

              subtitle:
                item.message_details.length > 0
                  ? item.message_details[0].message_text || "No message"
                  : "No message",
              date: new Date(
                item.message_details[0]?.message_date_time || Date.now()
              ),
              unread: parseInt(item.unread_message_count, 10),
              avatar: item.receptient_user_profile_pic
                ? `${NODE_URL + item.receptient_user_profile_pic}`
                : profilePic
            }
          })

          setChatList((prevChatList) => [
            ...prevChatList,
            ...formattedChatList,
          ])

          // Check if more data is available
          if (response.data.list.length < 8) {
            setHasMore(false); // No more pages to fetch
          }
        }
      })
      .catch((err) => {
        console.log("Error fetching chat list: ", err);
      })
      .finally(() => setIsLoading(false));
  };
  // Fetch Chat History Data based on the active chat
  const fetchChatHistoryApi = (threadId, pageNo) => {
    if (!threadId || pageNo === undefined) {
      console.error("Error: Missing threadId or pageNo!");
      return;
    }

    // Capture current scroll height before loading more messages
    const chatContainer = chatContainerRef.current;
    const previousScrollHeight = chatContainer ? chatContainer.scrollHeight : 0;

    axios(ApiConfig.CHAT_MESSAGE_LIST, {
      method: "GET",
      params: {
        thread_id: threadId,
        page_no: pageNo,
        page_limit: 10, // Load 10 messages per request
        teacher_id: Params.teacher_id,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Basic YnJva2VyOmJyb2tlcl8xMjM=",
        api_key: Params.api_key,
        customer_id: Params.customer_id,
      },
    })
      .then((response) => {
        if (response.data.result && response.data.data.length > 0) {
          const formattedMessages = response.data.data.map((msg) => ({
            position: msg.message_from_id === Params.teacher_id ? "right" : "left",
            name: msg.message_from_id === Params.teacher_id ? "Teacher" : activeChat.title,
            avatar: msg.message_from_id === Params.teacher_id ? "Teacher" : activeChat.avatar,
            type: "text",
            text: msg.message_text || "",
            date: new Date(msg.message_date_time),
            attachments: (msg.message_attachments || []).map((attachment) => ({
              url: `https://app.edsys.in:3000/${attachment.attachment_url}`,
              type: attachment.attachment_type,
              name: attachment.attachment_name,
            })),
          }));

          setMessages((prevMessages) => [...prevMessages, ...formattedMessages]); // Prepend new messages

          setTimeout(() => {
            if (chatContainer) {
              const newScrollHeight = chatContainer.scrollHeight;
              chatContainer.scrollTop = newScrollHeight - previousScrollHeight; // Maintain position
            }
          }, 100); // Small delay ensures new messages are rendered

          setPage((prevPage) => prevPage + 1);
        } else {
          console.log("No more messages to load.");
          setHasMore(false);
        }
      })
      .catch((err) => {
        console.log("Error fetching chat history: ", err);
      });
  };

  const fetchContactList = async () => {
    axios(ApiConfig.CHAT_USER_LIST, {
      method: "GET",
      params: {
        teacher_id: Params.teacher_id,
        search: searchQuery,
        page_no: pageNo,
        page_limit: pageLimit,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Basic YnJva2VyOmJyb2tlcl8xMjM=",
        api_key: Params.api_key,
        customer_id: Params.customer_id,
      },
    })
      .then((response) => {
        if (response.data.result && response.data.data) {
          // Check if more data is available
          console.log(response.data, "contact listsss");
          setNewChatList(response.data.data || []);
          setTotalPages(response.data.total_pages || 1);
          setTotalPages(Math.ceil(response.data.total_count / pageLimit));
        }
      })
      .catch((err) => {
        console.log("Error fetching chat list: ", err);
      })
      .finally(() => setIsLoading(false));
  };
  // new chat api
  const newChatApi = async (id) => {
    console.log("response.data)");
    try {
      const requestBody = {
        teacher_id: Params.teacher_id,
        recepient: id,
      };
      const response = await axios.post(
        ApiConfig.NEW_CHAT,
        requestBody,
        {
          headers: {
            api_key: Params.api_key,
            customer_id: Params.customer_id,
          },
        }
      );

      if (response.data) {
        console.log("response.data)", response.data);
        setActiveChat({
          id: response.data.thread_id,
          title: selectedContact.user_name,
          receiverId: selectedContact.user_id,
          subtitle: "new message",
          date: new Date(Date.now()),
          unread: parseInt(0, 10),
          avatar: selectedContact.user_profile_pic
            ? `${NODE_URL + selectedContact.user_profile_pic}`
            : "https://via.placeholder.com/150",
        });
        setMessages([]);
      }
    } catch (error) {
      console.log("api response", error);
    }
  };

  // Load the first page initially
  useEffect(() => {
    fetchChatList(page);
  }, [page]);
  // Load messages when an active chat is selected
  useEffect(() => {
    if (activeChat) {
      console.log(activeChat.id, "active id");
      setMessages([]); // Clear old messages
      setPage(1); // Reset pagination
      fetchChatHistoryApi(activeChat.id, 1); // Load first page
    }
  }, [activeChat]); // Runs when active chat changes

  useEffect(() => {
    if (messages.length > 0 && chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]); // Runs whenever messages change


  // Fetch on modal open
  useEffect(() => {
    if (showModal) fetchContactList();
  }, [showModal, searchQuery, pageNo]);
  // Load messages for the active chat
  // useEffect(() => {
  //   if (activeChat && messages.length === 0) {
  //     const newMessages = [
  //       {
  //         position: "left",
  //         type: "text",
  //         // text: `Chat with ${activeChat.title} started.`,
  //         date: new Date(),
  //       },
  //     ];
  //     setMessages(newMessages);
  //   }
  // }, [activeChat]);

  const handleSendMessage = () => {
    if (inputText.trim() !== "" || attachment) {
      const messageData = {
        customer_id: Params.customer_id,
        chatRoomId: activeChat.id,
        receiver_role: "parent",
        senderID: Params.teacher_id,
        receiverId: activeChat.receiverId,
        message: inputText,
        file: [], // Initialize empty attachments array
      };

      if (attachment) {
        const reader = new FileReader();
        reader.onload = () => {
          const base64File = reader.result.split(",")[1]; // Extract base64 content

          // Create the attachment object
          const attachmentData = {
            file_attach: base64File, // Use the Base64 content here
            file_type: attachment.type.startsWith("image/")
              ? "image"
              : attachment.type.startsWith("video/")
                ? "video"
                : attachment.type.startsWith("audio/")
                  ? "audio"
                  : "file",
            file_name: attachment.name,
          };
          console.log(attachmentData, "base64dataaaa");
          // Add the attachment to the message_attachments array
          messageData.file.push(attachmentData);

          // Emit message with attachment
          socket.current.emit("message_sent", messageData);

          // Clear input and preview after sending
          setInputText("");
          setAttachment(null);
          setAttachmentPreview(null);
        };
        reader.readAsDataURL(attachment);
      } else {
        // Emit message without attachment
        socket.current.emit("message_sent", messageData);

        // Clear input
        setInputText("");
      }
    }
  };

  const handleAttachmentChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAttachment(file);

      // Create a preview URL for the file
      const previewURL = URL.createObjectURL(file);
      setAttachmentPreview({
        name: file.name,
        type: file.type,
        url: previewURL,
      });
    }
  };
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPageNo(1); // Reset to first page on new search
  };
  const handleContactSelect = (contact) => {
    setSelectedContact(contact);
  };

  console.log("this is messages ", messages);

  //Translation
  const { t } = useTranslation();
  console.log(chatList, "chatlist");
  const chatContainerRef = useRef(null);
  useEffect(() => {

    setPage(1); // Reset to the first page
    fetchChatHistoryApi(1); // Fetch filtered data
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!chatContainerRef.current) return;

      if (chatContainerRef.current.scrollTop === 0) {
        console.log("🔼 User scrolled to the top!");
        setPage((prev) => {
          const nextPage = prev + 1;
          fetchChatHistoryApi(activeChat?.id, nextPage); // Ensure both are passed
          return nextPage;
        });
      }
    };

    const chatContainer = chatContainerRef.current;
    if (chatContainer) {
      chatContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (chatContainer) {
        chatContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [page, activeChat]); // Include activeChat to refetch on chat change
  //sorting date
  //date filter
  const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, msg) => {
      const messageDate = new Date(msg.date);
      const formattedDate = messageDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      const today = new Date();
      const todayFormatted = today.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      const displayDate = formattedDate === todayFormatted ? "Today" : formattedDate;

      if (!acc[displayDate]) {
        acc[displayDate] = [];
      }
      acc[displayDate].push(msg);
      return acc;
    }, {});
  };

  const groupedMessages = groupMessagesByDate(messages.slice(0).reverse());
  return (
    <div className="chat-container">
      {/* Sidebar */}
      {/* <div class="chat-sidebar">
    <h2 style="color: rgb(120, 38, 106); font-size: 20px; padding-left: 10px; font-weight: 500;">
        Chats
    </h2>
    <div class="rce-container-clist chat-list">
        <div class="rce-container-citem">
            <div class="rce-citem">
                <div class="rce-citem-avatar">
                    <div class="rce-avatar-container circle large">
                        <img src="https://app.edsys.in:3000/uploads/1005/user/Anil_115340.jpeg" 
                             class="rce-avatar"/>
                    </div>
                </div>
                <div class="rce-citem-body">
                    <div class="rce-citem-body--top">
                        <div class="rce-citem-body--top-title">Anil</div>
                        <div class="rce-citem-body--top-time">2 hours ago</div>
                    </div>
                    <div class="rce-citem-body--bottom">
                        <div class="rce-citem-body--bottom-title">Hello, how are you</div>
                        <div class="rce-citem-body--bottom-tools"></div>
                        <div class="rce-citem-body--bottom-tools-item-hidden-hover"></div>
                        <div class="rce-citem-body--bottom-status"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> */}

      <div className="chat-sidebar">
        <h2 style={{ color: "#78266a", fontSize: "20px", paddingLeft: "10px", fontWeight: "500" }}>{t("Chats")}</h2>
        <ChatList
          className="chat-list"
          dataSource={chatList}
          onClick={(chat) => setActiveChat(chat)}
        />

      </div>

      {/* Chat Window */}

      <div className="chat-window">
        {activeChat ? (
          <>
            {/* Header */}
            <div className="chat-header">
              <h3 style={{ color: "#78266a", fontSize: "20px", paddingLeft: "10px", fontWeight: "500", display: "flex", justifyContent: "center" }}>{activeChat.title}</h3>
            </div>
            {/* Messages */}
            <div id="chat-container" ref={chatContainerRef} style={{ height: "500px", overflow: "auto", background: "#e8ecf8", padding: "10px" }} className="chat-maindark">

              <InfiniteScroll
                dataLength={messages.length}
                next={() => {
                  fetchChatHistoryApi(activeChat?.id, page + 1); // Fetch next batch
                }}
                hasMore={hasMore}
                inverse={true}
                // loader={<p>Loading older messages...</p>}
                scrollableTarget="chat-container"
              >
                <div>
                  {Object.entries(groupedMessages).map(([date, msgs]) => (
                    <div key={date}>
                      <div
                        className="date-header"
                        style={{
                          textAlign: "center",
                          margin: "10px 0",
                          fontWeight: "bold",
                          background: "#e8ecf8",
                          padding: "5px",
                          borderRadius: "10px",
                          fontWeight: "400"
                        }}
                      >
                        {date}
                      </div>
                      {msgs.map((msg, index) => (
                        <div key={index} style={{ display: "flex", flexDirection: msg.position === "right" ? "row-reverse" : "row", alignItems: "center", marginBottom: "10px" }}>
                          {/* Avatar */}
                          <div style={{ width: "40px", height: "40px", borderRadius: "50%", overflow: "hidden", margin: "0 10px" }}>
                            <img src={msg.avatar === "Teacher" ? "https://app.edsys.in:3000/uploads/1005/user/ddwztc1716179911.jpeg" : msg.avatar} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          </div>

                          {/* Message Box */}
                          <div
                            style={{
                              background: msg.position === "right" ? "#DCF8C6" : "#FFF",
                              padding: "10px",
                              borderRadius: "10px",
                              maxWidth: "70%",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                              position: "relative",
                            }}
                          >
                            <div style={{ fontSize: "14px", marginBottom: "5px" }}>{msg.text}</div>

                            {/* Attachments */}
                            {msg.attachments.length > 0 && (
                              <div>
                                {msg.attachments.map((attachment, idx) => (
                                  <div key={idx} style={{ marginTop: "8px" }}>
                                    {attachment.type === "image" ? (
                                      <img
                                        src={attachment.url}
                                        alt="attachment"
                                        style={{ maxWidth: "200px", maxHeight: "200px", borderRadius: "8px", cursor: "pointer" }}
                                        onClick={() => window.open(attachment.url, "_blank")}
                                      />
                                    ) : attachment.type === "video" ? (
                                      <video controls style={{ maxWidth: "200px", borderRadius: "8px" }}>
                                        <source src={attachment.url} type="video/mp4" />
                                        Your browser does not support the video tag.
                                      </video>
                                    ) : (
                                      <a href={attachment.url} target="_blank" rel="noopener noreferrer">
                                        {attachment.name || "Download Attachment"}
                                      </a>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Timestamp */}
                            <div style={{ fontSize: "10px", textAlign: "right", color: "#888", marginTop: "5px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
                              {new Date(msg.date).toLocaleTimeString("en-US", {
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })}
                              {msg.position === "right" ? <div style={{ background: "#fff", padding: "3px 3px 2px 2px", borderRadius: "50%", display: "flex" }}><svg
                                width="15"
                                height="15"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="blue"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"

                              >
                                <polyline points="4 12 9 17 20 6" />
                                <polyline points="10 12 15 17 24 6" />
                              </svg>
                              </div> : null}


                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            </div>

            {/* Input Field */}
            <div className="chat-input"
            // style={{position:"relative"}}
            >
              {attachmentPreview && (
                <div className="attachment-preview-small">
                  {attachmentPreview.type.startsWith("image/") ? (
                    <img
                      src={attachmentPreview.url}
                      alt={attachmentPreview.name}
                      className="attachment-image-small"
                    />
                  ) : (
                    <p className="attachment-file-name">
                      {attachmentPreview.name}
                    </p>
                  )}
                  <button
                    className="remove-preview-button"
                    onClick={() => setAttachmentPreview(null)}
                  >
                    X
                  </button>
                </div>
              )}
              <input
                type="file"
                id="file-input"
                style={{ display: "none" }}
                onChange={handleAttachmentChange}
              />
              <div className="input-buttons-container">
                <div className="input-wrapper">
                  <Input
                    placeholder="Type a message..."
                    multiline={false}
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault(); // Prevents a new line from being added
                        handleSendMessage();
                      }
                    }}
                  />
                </div>
                <div className="buttons-wrapper">
                  <button
                    className="icon-button"
                    onClick={() =>
                      document.getElementById("file-input").click()
                    }
                  >
                    <FaPaperclip size={20} />
                  </button>
                  <button className="icon-button" onClick={handleSendMessage}>
                    <FaPaperPlane size={20} />
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="chat-placeholder">
            <h3 style={{ color: "#78266a", fontSize: "20px", paddingLeft: "10px", fontWeight: "500", display: "flex", justifyContent: "center" }}>{t("Select a chat to start messaging")}</h3>
          </div>
        )}
      </div>
      {/* <button className="floating-add-btn" onClick={() => setShowModal(true)}>
        <FaPlus size={24} />
      </button> */}
      {/* <!-- Button trigger modal --> */}
      <button
        type="button"
        className="floating-add-btn"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop"
        onClick={toggleModal}
      >
        <FaPlus size={24} />
      </button>

      {/* <!-- Modal --> */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden={!showModal}
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                {t("Contact List")}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={toggleModal}
              ></button>
            </div>
            <div
              className="modal-body overflow-auto"
              style={{ maxHeight: "400px" }}
            >
              {/* Search Input */}
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Search contacts..."
                value={searchQuery}
                onChange={handleSearch}
              />

              {/* Contact List */}
              {isLoading ? (
                <p>{t("Loading...")}</p>
              ) : (
                <ul className="list-group">
                  {newChatList.map((contact, index) => (
                    <li
                      key={index}
                      className={`list-group-item d-flex align-items-center ${selectedContact === contact
                        ? "bg-primary text-white"
                        : ""
                        }`}
                      onClick={() => handleContactSelect(contact)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={contact.profilePic}
                        alt={contact.name}
                        className="rounded-circle me-3"
                        style={{ width: "50px", height: "50px" }}
                      />
                      <div>
                        <strong>{contact.user_name}</strong> <br />
                        <small>{contact.user_role}</small> <br />
                        <small>{contact.phone}</small>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-between p-3">
              <button
                className="btn btn-secondary"
                onClick={() => setPageNo((prev) => Math.max(prev - 1, 1))}
                disabled={pageNo === 1}
              >
                {t("Previous")}
              </button>
              <span>
                {t("Page")}   {pageNo} of {totalPages}
              </span>
              <button
                className="btn btn-secondary"
                onClick={() =>
                  setPageNo((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={pageNo >= totalPages}
              >
                {t("Next")}
              </button>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={toggleModal}
              >
                {t("Close")}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  toggleModal();
                  newChatApi(selectedContact?.user_id);
                }}
                disabled={!selectedContact}
              >
                {t("New Chat")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
